<template>
    <div :class="[variant == 'default'?'item':'user-item',item.f_select ? 'selected':'']"
        @click="onclick"
        @mousedown="on_down"
        @mouseup="on_up"
    >
      <template v-if="itemType == 'community'">
        <div v-if="variant == 'default'" class="left">
          <div v-if="isNewCommunity(item.f_reg_time)" class="new_badge">
            <!--        <div v-if="num == 1" class="new_badge">-->
            N
          </div>
          <div v-else class="number" >{{num}}</div>
          <div v-if="item.f_made1 == 'Y'" class="made_wrapper">
            <!--        <div v-if="num == 2" class="made_wrapper">-->
            메이드+
          </div>
          <div  class="label">{{$c.COMMUNITY_CATEGORY[item.f_type]}}</div>
<!--          <div  class="title" :style="{maxWidth: item.f_made == 'Y' ? '60%':'70%'}">{{item.f_title}}</div>-->
          <div  class="title" style="flex:1">{{item.f_title}}</div>
          <!--        <div  class="title" :style="{maxWidth: false ? '60%':'70%'}">{{item.f_title}}</div>-->
        </div>
        <div v-else class="left">
          <div v-if="isNewCommunity(item.f_reg_time)" class="new_badge">
            <!--        <div v-if="num == 1" class="new_badge">-->
            N
          </div>
          <div v-if="item.f_made1 == 'Y'" class="made_wrapper">
            <!--        <div v-if="num == 2" class="made_wrapper">-->
            메이드+
          </div>
          <div v-if="(item.f_made1 == 'Y' && currentTab != $c.COMMUNITY_TYPE.ALL) || currentTab == $c.COMMUNITY_TYPE.ALL"
               class="label">
            {{$c.COMMUNITY_CATEGORY[item.f_type]}}
          </div>
<!--          <div class="title"-->
<!--               :style="{-->
<!--          maxWidth: (item.f_made1 == 'Y' && currentTab != $c.COMMUNITY_TYPE.ALL) || currentTab == $c.COMMUNITY_TYPE.ALL ? '70%':'80%'}">-->
<!--            {{item.f_title}}</div>-->
        <div class="title"
               >
            {{item.f_title}}
          <span v-if="item.comment_count > 0" class="notice_comment">
            [{{item.comment_count}}]
          </span>
        </div>
          <!--        <div  class="title" :style="{maxWidth: false ? '60%':'70%'}">{{item.f_title}}</div>-->
        </div>
      </template>
      <template v-else>
<!--        inquire내용입니다.-->
        <div class="left">
          <b-img v-if="item.f_secret == 'Y'" :src="require('../../assets/image/ic_secret@2x.png')" style="height: 1.8em; margin-top: 8px;"/>
          <div v-if="item.f_answer != ''" class="answer_complete">{{$t("inquire.answer_complete")}}</div>
          <div class="label" >
            {{$c.INQUIRE_CATEGORY1[item.f_type]}}
          </div>
          <div class="title">
            {{item.f_title}}</div>
        </div>

      </template>

      <div  class="time" >{{renderTime(item.f_reg_time)}}</div>
    </div>
</template>

<script>
import moment from "moment";

export default {
  name: "CommunityItem",
  props:{
    item:{type:Object},
    num:{type:Number},
    variant:{type:String,default:'default'},
    currentTab:{type:String},
    itemType:{type:String,
    default:'community'}
  },
  data() {
    return {
      timeID:0,
      long:false,
    }
  },
  methods:{
    onclick(){
      if (!this.long){
        this.$emit('click');
      }
    },
    on_down(){
      var self = this;
      this.timeID = setTimeout(function (){
        self.$emit('longClick');
        self.long = true;
      }, 500);
    },
    on_up(){
      var self = this;
      setTimeout(function (){
        self.long = false;
      }, 100);
      clearTimeout(this.timeID);
    },
    isNewCommunity(date_time){
      return moment(date_time).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD');
    },
    renderTime(date_time){
      if (moment(date_time).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {
        return moment(date_time).format('HH:mm');
      } else {
        return moment(date_time).format('MM/DD');
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/_vars.scss';
.item{
  font-size: $fs_11;
  //font-family: $korean_gd_12_r;
  height: 50px;
  border-radius: 6px;
  background: $white;
  margin: 1em;
  padding: 0.5em;
  border: solid 1px #dfdcdc;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 2px rgba(0,0,0,0.08);
}


.user-item{
  font-size: $fs_11;
  height: 40px;
  border-bottom: solid 0.5px #f6f4f4;
  padding: 1em 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}


.label{
  height: 30px;
  width: 76px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $primary;
  border: solid 2px $primary;
  border-radius: 7px;
  padding: 0;
  //margin-left: 3px;
  font-size: $fs_16;
  font-family: $korean_gd_15_r;
  margin-top: 6px;
}

.title{
  //max-width: 60%;
  flex:1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  //padding-left: 0.5em;
  font-size: $fs_18;
  display: block;
  font-family: $korean_gd_13_r;
  height: 40px;
  padding-top: 8px;
  margin-left: 7px;
}

.time{
  width: 10%;
  color: #a2a2a2;
  padding-left: 7px;
  text-align: right;
  font-size: $fs_14;
  font-family: $korean_gd_14_r;
  margin-right: 5px;
}

.number{
  width: 15px;
  margin-right: 0.5em;
  text-align: center;
}

.new_badge{
  display: flex;
  width: 20px;
  margin-right: 0.5em;
  height: 20px;
  border-radius: 3px;
  background-color: #cf0000;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: $white;
  font-size: $fs_13;
  margin-top: 9px;
}

.made_wrapper{
  display: flex;
  margin-right: 7px;
  background-color: #cf0000;
  border-radius: 2px;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 61px;
  color: $white;
  font-size: $fs_16;
  font-family: $korean_gd_16_r;
  border-radius: 3px;
  padding: 0 5px;
  margin-top: 8px;
}
.left{
  min-width: 90%;
  display: flex;
}
.notice_comment{
  color: $black;
  font-size: $fs_17;
  font-family: $korean_gd_16_r;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/CommunityItem.vue